export default [
  {
    position: "absolute",
    top: 23.4,
    left: 17,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "assessmentP2.mTitleOne",
    mBody: "assessmentP2.mBodyOne",
    id: "SP_CompetencyAssessment_Info_SkillDevelopment",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 0.4,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "assessmentP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_CompetencyAssessment_Navigation_Menu",
    index: 1,
  },
  {
    position: "absolute",
    top: 0.4,
    left: 23,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "assessmentP2.ttTextTwo",
    hover: false,
    tooltipClass: "right",
    id: "SP_CompetencyAssessment_Navigation_Communications",
    index: 2,
  },
  {
    position: "absolute",
    top: 2.7,
    left: 27.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "assessmentP2.ttTextFour",
    hover: false,
    id: "SP_CompetencyAssessment_Navigation_Absence",
    index: 3,
  },
  {
    position: "absolute",
    top: 2.7,
    left: 34.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "assessmentP2.ttTextSeven",
    hover: false,
    id: "SP_CompetencyAssessment_Navigation_Performance",
    index: 4,
  },
  {
    position: "absolute",
    top: 2.1,
    left: 98.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "assessmentP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_CompetencyAssessment_Navigation_TeamMember",
    index: 5,
  },
];
